// extracted by mini-css-extract-plugin
export default {"mainContainer":"List_mainContainer__kNCJU"};